<div class="login-section">
  <div class="login-container">
    <div class="login-upper-section">
      <span class="login-title-text">Login to dp</span>
      <div class="login-field-secton">
        <form [formGroup]="loginForm">
          <div class="input-field-container">
            <span class="input-level-text">Email address*</span>
            <input
              type="text"
              class="input-field dp-input-control"
              placeholder="Enter your email address"
              formControlName="email"
              (keyup)="onInputBlur('email')"
              (blur)="onInputBlur('email')"
            />
            @if (emailInvalid) {
            <span class="error-message">Enter a valid email</span>
            }
          </div>
          <div class="input-field-container">
            <span class="input-level-text">Password*</span>
            <div class="password-container">
              <input
                [type]="passwordVisible ? 'text' : 'password'"
                class="input-field dp-input-control"
                placeholder="Enter your password"
                formControlName="password"
                (keyup)="onInputBlur('password')"
                (blur)="onInputBlur('password')"
              />
              @if (loginForm.get('password')?.value) {
              <div
                class="password-icon"
                [ngStyle]="{
                  'background-image': passwordVisible
                    ? 'var(' + visibilityOnIcon + ')'
                    : 'var(' + visibilityOffIcon + ')'
                }"
                (click)="togglePasswordVisibility()"
              ></div>
              }
            </div>
            @if (passwordInvalid) {
            <span class="error-message"> Enter a valid password </span>
            }
          </div>
          @if(requireFc){
          <div class="input-field-container">
            <span class="input-level-text">Family code*</span>

            <input
              type="text"
              formControlName="fc"
              placeholder="Enter FC as per Arghya Prasasthi"
              class="input-field dp-input-control"
              (keydown)="restrictFCInput($event)"
              [matAutocomplete]="autofc"
              (input)="onInputChange()"
            />

            <mat-autocomplete autoActiveFirstOption #autofc="matAutocomplete">
              @for (item of fcDetails ; track item) {
              <mat-option
                [value]="item.name + ' ' + item.lastName"
                (onSelectionChange)="getMemKey(item)"
              >
                {{ item.name }} {{ item.lastName }}
              </mat-option>
              }
            </mat-autocomplete>
            @if(!fcVerifiedIcon ){
            <img
              src="../../../assets/images/fcNotVerified.svg"
              class="input-cross-icon position-absolute"
            />
            } @if(fcVerifiedIcon && !crossIconVissible){
            <img
              src="../../../assets/images/fcVerified.svg"
              class="input-cross-icon position-absolute"
            />
            } @if(crossIconVissible){
            <img
              src="../../../assets/images/crossIconDarkTheme.svg"
              class="input-cross-icon position-absolute"
              (click)="clearFc()"
            />
            }
          </div>
          <!-- @if(loginForm .get('fc')?.invalid || !selectedFC){
              <span class="error-text">select member from dropdown</span>
            } -->
          } @if(!requireFc){
          <button
            class="login-button dp-primary-btn"
            [ngClass]="[isloadingSpin ? 'spinner' : '']"
            (click)="initiateLoginAndProcess()"
            [disabled]="isloadingSpin"
          >
            @if(!isloadingSpin){
            <span>Login</span>
            }</button
          >} @if(requireFc){
          <button
            class="login-button dp-primary-btn"
            [ngClass]="[isloadingSpin ? 'spinner' : '']"
            (click)="secondAPIcall()"
          >
            @if(!isloadingSpin){
            <span>Login</span>
            }</button
          >}
        </form>

        <a [routerLink]="'/reset-password'" class="forgot-password-text"
          >Forgot password?</a
        >
      </div>
    </div>
    <div class="footer-section">
      <div class="registration-ask-text">Not registered with DP Works?</div>
      <a [routerLink]="'/create-account'" class="registration-now-text"
        >Register now</a
      >
      <div class="policy-text">
        By getting started, you agree to our
        <a
          href="https://map.satsangphilanthropy.com/dpworks/policy_dpworks_web.pdf"
          >Privacy Policy</a
        >
        and
        <a
          href="https://map.satsangphilanthropy.com/dpworks/policy_dpworks_web.pdf"
          >Terms & Conditions</a
        >
      </div>
    </div>
  </div>
</div>
